import { render, staticRenderFns } from "./LotteryParent.vue?vue&type=template&id=29b3c007&scoped=true"
import script from "./LotteryParent.vue?vue&type=script&lang=js"
export * from "./LotteryParent.vue?vue&type=script&lang=js"
import style0 from "./LotteryParent.vue?vue&type=style&index=0&id=29b3c007&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b3c007",
  null
  
)

export default component.exports